import { ModalBody, ModalFooter, Button } from 'reactstrap'

import { Modal } from 'components/common/Modal/Modal'
import { Notification } from 'components/common/Notification/Notification'

import styles from './styles.module.scss'

import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  isOpen: boolean
  title: string
  approveLabel?: string
  approveColor?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'link'
  approveDisabled?: boolean
  errorMessage?: string
  showApprove?: boolean
  onCancel: () => void
  onApprove?: () => void
  onHideNotification?: () => void
  submitName?: string // APMを判別するための文字列
  overflow?: string
}

const CustomModal = ({
  children,
  isOpen,
  title,
  approveLabel = '保存',
  approveColor = 'primary',
  approveDisabled = false,
  errorMessage = '',
  showApprove = true,
  onCancel,
  onApprove,
  onHideNotification = () => {},
  submitName,
  overflow,
}: Props) => {
  return (
    <Modal isOpen={isOpen} overflow={overflow}>
      <ModalBody className="font-large fw-bold">{title}</ModalBody>

      {errorMessage && (
        <Notification
          className={styles.notification}
          errorMessage={errorMessage}
          error={!!errorMessage}
          hide={onHideNotification}
        />
      )}

      <ModalBody>{children}</ModalBody>

      <ModalFooter className="d-flex justify-content-between">
        <Button outline onClick={onCancel}>
          {showApprove ? 'キャンセル' : '閉じる'}
        </Button>
        {showApprove && (
          <Button color={approveColor} disabled={approveDisabled} onClick={onApprove} name={submitName}>
            {approveLabel}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  )
}

export default CustomModal
